export const UserRoles = [
  { label: "Admin", value: 1 },
  { label: "RA", value: 2 },
  { label: "BDM", value: 3 },
  { label: "Recruiter", value: 4 },
  { label: "HR", value: 5 },
  { label: "Finance", value: 6 },
  { label: "Employee", value: 7 },
];

export const UserDesignations = [
  { label: "Junior", value: 1 },
  { label: "Senior", value: 2 },
  { label: "Lead", value: 3 },
  { label: "Manager", value: 4 },
  { label: "Employee", value: 5 },
];

export const OrganizationStatus = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
];

export const CompanyStatus = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
  { label: "Blocked", value: 3 },
  { label: "DNC", value: 4 },
];

export const EmploymentType = [
  { label: "Regular", value: 1 },
  { label: "Permanent", value: 2 },
  { label: "Contractor", value: 3 },
  { label: "Reference", value: 4 },
];

export const Gender = [
  { label: "Male", value: 1 },
  { label: "Female", value: 2 },
  { label: "Wish not to specify", value: 3 },
  { label: "Other", value: 4 },
];

export const careerbuilderOptions = [
  { label: "‘Most Recent Pay’ ascending", value: "+RECENTYEARLYPAY" },
  { label: "‘Most Recent Pay’ descending", value: "-RECENTYEARLYPAY" },
  { label: "‘Freshness’ ascending", value: "+MODIFIEDINT" },
  { label: "‘Freshness’ descending", value: "-MODIFIEDINT" },
  { label: "‘Relevance’ ascending", value: "+RELV" },
  { label: "‘Relevance’ descending", value: "-RELV" },
  ,
];

export const monsterSearchOptions = [
  { label: "Default", value: "rank,distance,mdate" },
  { label: "Resume Title", value: "Title" },
  { label: "Resume Updated", value: "Mdate" },
  { label: "Location", value: "Distance" },
  { label: "Relevence", value: "Rank" },
];

export const EmployeeStatus = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
  { label: "On Hold", value: 3 },
  { label: "Rejected", value: 4 },
  { label: "Resign", value: 5 },
  { label: "Termination", value: 6 },
];
export const BenchsalesCandidateStatusOptions = [
  { label: "Active", value: 1 },
  { label: "Selected", value: 2 },
  { label: "Rejected", value: 3 },
];

export const EmployeeTagJobStatus = [
  { label: "Active", value: 1 },
  { label: "Open", value: 2 },
];

export const EmployeeClassification = [
  { label: "Billable", value: 1 },
  { label: "Non-Billable", value: 2 },
];

export const EmployeeExitType = [
  { label: "Employment Exit", value: 1 },
  { label: "Contract Expiry", value: 2 },
  { label: "Resignation", value: 3 },
  { label: "Termination", value: 4 },
  { label: "Retirement", value: 5 },
  { label: "Serving Notice", value: 6 },
];

export const InvoiceBillType = [
  { label: "Salary", value: 1 },
  { label: "Incentives", value: 2 },
  { label: "Bonus", value: 3 },
  { label: "Allowance", value: 4 },
];

export const InvoiceStatus = [
  { label: "Active", value: 1 },
  { label: "Open", value: 2 },
];

export const JobStatus = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
];

export const ContactStatus = [
  { label: "Active", value: 1 },
  { label: "Open", value: 2 },
];

export const RecordStatus = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
];

export const ClientOwnership = [
  { label: "Visible to All", value: 1 },
  { label: "Visible to Selected Owners", value: 2 },
];

export const ContactType = [
  { label: "Primary", value: 1 },
  { label: "Secondary", value: 2 },
];

export const CurrencyType = [
  { label: "USD", value: 1 },
  { label: "INR", value: 2 },
];

export const CommissionType = [
  { label: "Flat", value: 1 },
  { label: "Percentage", value: 2 },
];

export const NotifierDefault = [
  { label: "End Client Name", value: 1 },
  { label: "Location", value: 2 },
  { label: "Employee Name", value: 3 },
  { label: "Job Start Date", value: 4 },
  { label: "Job End Date", value: 5 },
  { label: "Job Title", value: 6 },
  { label: "Employee ID", value: 7 },
];

export const VisibilityStatus = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
];

export const DiscountType = [
  { label: "Value", value: 1 },
  { label: "Percentage", value: 2 },
];

export const InvoiceDateCalculation = [
  { label: "Last Date of Timesheet in Invoice Line Items", value: 1 },
  { label: "Invoice Creation Date", value: 2 },
];

export const InvoiceDueDateCalculation = [
  { label: "Shipped Date", value: 1 },
  { label: "Invoice Date", value: 2 },
];

export const BusinessSize = [
  { label: "Small", value: 1 },
  { label: "Medium", value: 2 },
  { label: "Large", value: 3 },
];

export const BusinessType = [
  { label: "Corporation", value: 1 },
  { label: "Franchise", value: 2 },
  { label: "LLC", value: 3 },
  { label: "Partnership", value: 4 },
  { label: "Solo Proprietor", value: 5 },
];

export const BankAccType = [
  { label: "Savings", value: 1 },
  { label: "Checking", value: 2 },
  { label: "Current", value: 3 },
];

export const DepositAmtType = [
  { label: "Full", value: 1 },
  { label: "Partial", value: 2 },
];

export const Ethnicity = [
  { label: "Asian", value: 1 },
  { label: "Black / African", value: 2 },
  { label: "Hispanic / Latino", value: 3 },
  { label: "White / Caucasian", value: 4 },
  { label: "Middle Eastern / North African", value: 5 },
  { label: "Native American / Indigenous", value: 6 },
  { label: "Pacific Islander", value: 7 },
  { label: "Mixed / Multiracial", value: 8 },
  { label: "Other", value: 9 },
  { label: "Prefer not to say", value: 10 },
];

export const WADocStatus = [
  { label: "Active", value: 1 },
  { label: "Filed Extension", value: 2 },
  { label: "Inactive", value: 3 },
];

// export const WADocType = [
//   { label: "Citizen", value: 1 },
//   { label: "CPT", value: 2 },
//   { label: "Driving License", value: 3 },
//   { label: "GC EAD", value: 4 },
//   { label: "Green Card", value: 5 },
//   { label: "H-1B", value: 6 },
//   { label: "H4", value: 7 },
//   { label: "H4 EAD", value: 8 },
//   { label: "L2 EAD", value: 9 },
//   { label: "OPT", value: 10 },
//   { label: "STEM OPT", value: 11 },
// ];

export const H1BStatus = [
  { label: "Draft", value: 1 },
  { label: "Filed", value: 2 },
  { label: "Approved", value: 3 },
  { label: "RFE Received", value: 4 },
  { label: "RFE Responded", value: 5 },
  { label: "RFE Approved", value: 6 },
  { label: "RFE Denied", value: 7 },
  { label: "Denied", value: 8 },
  { label: "Rejected", value: 9 },
  { label: "Motion to Re-Open", value: 10 },
  { label: "Revoked", value: 11 },
  { label: "Withdrawn", value: 12 },
  { label: "End of Workflow", value: 13 },
  { label: "Filed Extension", value: 14 },
];

export const PassportStatus = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
];

export const DocumentStatus = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
];

export const PlacementType = [
  { label: "Contract", value: 1 },
  { label: "Permanent", value: 2 },
];

export const WorkLocationType = [
  { label: "Onsite", value: 1 },
  { label: "Remote", value: 2 },
  { label: "Offshore", value: 3 },
  { label: "Hybrid", value: 4 },
];

export const PayType = [
  { label: "Hourly", value: 1 },
  { label: "Salary", value: 2 },
];

export const BillRateType = [
  { label: "Per hour", value: 1 },
  { label: "Per day", value: 2 },
  { label: "Per week", value: 3 },
  { label: "Per month", value: 4 },
  { label: "Per annum", value: 5 },
];

export const TimesheetCycles = [
  { label: "Daily", value: 1 },
  { label: "Weekly", value: 2 },
  { label: "Biweekly", value: 3 },
  { label: "Monthly", value: 4 },
  { label: "Semi Monthly", value: 5 },
  { label: "By Dates", value: 6 },
  {
    label: "Apex Calendar",
    value: 7,
  },
];

export const Weekdays = [
  { label: "Monday", value: 1 },
  { label: "Tuesday", value: 2 },
  { label: "Wednesday", value: 3 },
  { label: "Thursday", value: 4 },
  { label: "Friday", value: 5 },
  { label: "Saturday", value: 6 },
  { label: "Sunday", value: 7 },
];

export const TimesheetFormat = [
  { label: "Regular", value: 1 },
  { label: "Timesheets with Time Clock", value: 2 },
];

export const TimesheetSubmitMethod = [
  { label: "Individual Timesheets", value: 1 },
  { label: "On Behalf of Employees", value: 2 },
];

export const ApprovalType = [
  { label: "Internal", value: 1 },
  // { label: "External", value: 2 },
];

export const BillType = [
  { label: "Billable", value: 1 },
  { label: "Non-billable", value: 2 },
];

export const RHSCOptions = [
  { label: "Show Warning Only", value: 1 },
  { label: "Restrict", value: 2 },
  { label: "Do Nothing", value: 3 },
];

export const TimesheetStatus = [
  // { label: "Weekends", value: 1 },
  // { label: "Draft", value: 2 },
  // { label: "Submitted", value: 3 },
  // { label: "Approved", value: 4 },
  // { label: "Rejected", value: 5 },
  // { label: "Job Inactive", value: 6 },
  // { label: "Leave", value: 7 },
  // { label: "Discrepant", value: 8 },
  // { label: "Invoiced", value: 9 },
  { label: "Draft", value: 1 },
  { label: "Submitted", value: 2 },
  { label: "Approved", value: 3 },
  { label: "Rejected", value: 4 },
  { label: "Job Inactive", value: 5 },
  { label: "Invoiced", value: 6 },
];

export const LcaStatus = [
  { label: "Certified", value: 1 },
  { label: "Withdrawn", value: 2 },
  { label: "Denied", value: 3 },
  { label: "In Process", value: 4 },
];

export const visaClassificationOptions = [
  { label: "New Employment", value: 1 },
  { label: "Concurrent Employment", value: 2 },
  { label: "Extension", value: 3 },
  { label: "Change in Employer", value: 4 },
  {
    label: "Change in Previously Approved Employment",
    value: 5,
  },
  { label: "Amendment", value: 6 },
  { label: "Amendment & Extension", value: 7 },
  { label: "CAP Exempt COS", value: 8 },
  { label: "CAP EXEMPT Consular", value: 9 },
  { label: "Extension NPT ", value: 10 },
  { label: "Transfer MPT", value: 11 },
];

export const LcaAdsPostAt = [
  { label: "Employer's Location", value: 1 },
  { label: "Work Location", value: 2 },
];
export const PayFrequency = [
  { label: "Hourly", value: 1 },
  { label: "Weekly", value: 2 },
  { label: "Bi-Weekly", value: 3 },
  { label: "Semi-Monthly", value: 4 },
  { label: "Monthly", value: 5 },
  { label: "Yearly", value: 6 },
];

export const BasisOfH1B = [
  { label: "New Employment", value: 1 },
  { label: "Concurrent Employment", value: 2 },
  { label: "Extension", value: 3 },
  { label: "Change in Employer", value: 4 },
  { label: "Change in Previously Approved Employment", value: 5 },
  { label: "Amendment", value: 6 },
  { label: "Amendment & Extension", value: 7 },
  { label: "CAP Exempt COS", value: 8 },
  { label: "CAP EXEMPT Consular", value: 9 },
  { label: "Extension NPT", value: 10 },
  { label: "Transfer NPT", value: 11 },
];

export const VisaType = [
  { label: "B-1", value: 1 },
  { label: "H-1B", value: 2 },
];
export const LaborStatus = [
  { label: "Approved", value: 1 },
  { label: "Audit", value: 2 },
  { label: "Denied", value: 3 },
  { label: "Draft", value: 4 },
  { label: "In Progress", value: 5 },
];

//Accounts Payables Pages
export const PayableCategory = [
  { label: "Vendor Payment", value: "Vendor Payment" },
];
export const PayableType = [{ label: "C2C Payment", value: "C2C Payment" }];

export const InvoiceBy = [
  { label: "Vendor", value: 1 },
  { label: "Manual", value: 2 },
];
export const payCycle = [
  { label: "Vendor", value: 1 },
  { label: "Manual", value: 2 },
];

export const SalaryProfileCycles = [{ label: "Monthly", value: 1 }];
export const restrictedMenuIds = [
  "Pay Data Dashboard",
  "Pay Configuration",
  "Deductions",
  "Other Payment",
  "Unpaid Timesheet",
];
export const PlacementReferralType = [
  { label: "Vendor", value: 1 },
  { label: "Employee", value: 2 },
];

export const PayrollProviders = [
  { label: "Quickbooks", value: "Quickbooks" },
  // { label: "Others", value: "Others" },
  // { label: "Payroll Provider 2", value: 2 },
  // { label: "Payroll Provider 3", value: 3 },
  // { label: "Payroll Provider 4", value: 4 },
  // { label: "Payroll Provider 5", value: 5 },
];

// for jobboards
export const degreesOptions = [
  { label: "Bachelor of Science", value: "Bachelor of Science" },
  {
    label: "Industrial Design/Spatial Design",
    value: "Industrial Design/Spatial Design",
  },
  {
    label: "Bachelor's Degree, Computer Science, 4.0",
    value: "Bachelor's Degree, Computer Science, 4.0",
  },
  {
    label: "Bachelor of Commerce, Business and Accounting(started)",
    value: "Bachelor of Commerce, Business and Accounting(started)",
  },
  {
    label: "MA and Ph.D, Communication Theory",
    value: "MA and Ph.D, Communication Theory",
  },
  { label: "+2, Commerce", value: "+2, Commerce" },
  {
    label: "+2, Maths, Physics and Chemistry",
    value: "+2, Maths, Physics and Chemistry",
  },
  { label: "+2, Science", value: "+2, Science" },
  {
    label: ".NET Development Certificate",
    value: ".NET Development Certificate",
  },
  {
    label: "1 Year Certificate, CCNA Program",
    value: "1 Year Certificate, CCNA Program",
  },
  { label: "12th Std, Computer Science", value: "12th Std, Computer Science" },
  {
    label: "12th Std, High School/Secondary Diplomas and Certificates",
    value: "12th Std, High School/Secondary Diplomas and Certificates",
  },
  {
    label: "2 year degree, Electronics and Computer Science",
    value: "2 year degree, Electronics and Computer Science",
  },
  {
    label: "2 yr AAS, Computer Programming",
    value: "2 yr AAS, Computer Programming",
  },
  { label: "2005 4GL, Database", value: "2005 4GL, Database" },
  {
    label: "AA Level / AS Level / BTEC / NVQA Level, Information Technology",
    value: "AA Level / AS Level / BTEC / NVQA Level, Information Technology",
  },
  {
    label:
      "A lot of mathematics and science and a lot of everything else, too.",
    value:
      "A lot of mathematics and science and a lot of everything else, too.",
  },
  {
    label: "A+ Certification, Information Technology",
    value: "A+ Certification, Information Technology",
  },
  {
    label:
      "A+ Certification/Microsoft Certified Technology Specialist, Computer and Information Sciences and Support Services",
    value:
      "A+ Certification/Microsoft Certified Technology Specialist, Computer and Information Sciences and Support Services",
  },
  {
    label: "A+ TRAINING CERTIFICATE, Microcomputer Repair",
    value: "A+ TRAINING CERTIFICATE, Microcomputer Repair",
  },
  { label: "A.A, Journalism", value: "A.A, Journalism" },
  {
    label: "A.A.S, Networking Technology (NET)",
    value: "A.A.S, Networking Technology (NET)",
  },
  {
    label: "A.A.S., Information Technology",
    value: "A.A.S., Information Technology",
  },
  {
    label: "A.A.S., Network Technology and Security",
    value: "A.A.S., Network Technology and Security",
  },
  { label: "A.Arts", value: "A.Arts" },
  { label: "A.S, General Studies", value: "A.S, General Studies" },
  {
    label: "A.S. in Digital Media & Web Development",
    value: "A.S. in Digital Media & Web Development",
  },
  { label: "A.S", value: "A.S" },
  {
    label: "A.A.S., Business Administration",
    value: "A.A.S., Business Administration",
  },
  { label: "AA", value: "AA" },
  { label: "AA Degree, Persian Farsi", value: "AA Degree, Persian Farsi" },
  { label: "AA, Business Technology", value: "AA, Business Technology" },
  { label: "AA, Computer Technology", value: "AA, Computer Technology" },
  { label: "AA, Data Processing", value: "AA, Data Processing" },
  { label: "AA, Electronics", value: "AA, Electronics" },
  {
    label: "AA, Health, Science, and Math",
    value: "AA, Health, Science, and Math",
  },
  { label: "AA, Paralegal", value: "AA, Paralegal" },
  {
    label: "AAS, Computer & Information Science",
    value: "AAS, Computer & Information Science",
  },
  {
    label: "AAS, Computer and Electronic Engineering Technology",
    value: "AAS, Computer and Electronic Engineering Technology",
  },
  {
    label: "AAS, Electronics Engineering Technology",
    value: "AAS, Electronics Engineering Technology",
  },
  {
    label: "AAS, Industrial Electronics",
    value: "AAS, Industrial Electronics",
  },
  { label: "AB, Business/Computers", value: "AB, Business/Computers" },
  { label: "Accountancy", value: "Accountancy" },
  { label: "Accounting", value: "Accounting" },
  {
    label: "Accounting Technology/Technician and Bookkeeping",
    value: "Accounting Technology/Technician and Bookkeeping",
  },
  {
    label: "Advanced Study Program, Electrical Engineering & Computer Science",
    value: "Advanced Study Program, Electrical Engineering & Computer Science",
  },
  {
    label: "Advanced High School Diploma",
    value: "Advanced High School Diploma",
  },
  {
    label: "Advanced Web Design Certification, Web Design",
    value: "Advanced Web Design Certification, Web Design",
  },
  { label: "A+", value: "A+" },
  {
    label: "Aeronautic Engineering Technology",
    value: "Aeronautic Engineering Technology",
  },
  {
    label: "Aeronautics/Aviation/Aerospace Science and Technology, General",
    value: "Aeronautics/Aviation/Aerospace Science and Technology, General",
  },
  {
    label: "AGILE Certification, Agile Product Owner, Silver Certified",
    value: "AGILE Certification, Agile Product Owner, Silver Certified",
  },
  {
    label: "Agile Project Management, Computer Science, Management",
    value: "Agile Project Management, Computer Science, Management",
  },
  { label: "Agricultural Economics", value: "Agricultural Economics" },
  {
    label: "Airecrew Life Support Specialist, Aircrew Life Support",
    value: "Airecrew Life Support Specialist, Aircrew Life Support",
  },
  {
    label: "AMSP, Multimedia Specialization",
    value: "AMSP, Multimedia Specialization",
  },
  {
    label: "Architecture, Art History, Psychology, Structural Engineering",
    value: "Architecture, Art History, Psychology, Structural Engineering",
  },
  {
    label: "Architecture/Mechanical Design",
    value: "Architecture/Mechanical Design",
  },
  { label: "Artificial Intelligence", value: "Artificial Intelligence" },
  {
    label: "AS, Computer Animation/Multimedia",
    value: "AS, Computer Animation/Multimedia",
  },
  { label: "AS, Multimedia", value: "AS, Multimedia" },
  {
    label: "ASEET, Electrical Engineering Technology",
    value: "ASEET, Electrical Engineering Technology",
  },
  {
    label: "Associate of Science in MIS",
    value: "Associate of Science in MIS",
  },
  { label: "Associate", value: "Associate" },
  { label: "Associate’s Degree", value: "Associate’s Degree" },
  {
    label: "Associate Degree, Cisco Certified Network Associate",
    value: "Associate Degree, Cisco Certified Network Associate",
  },
  {
    label: "Associate Degree, Computer Science & Business Administration",
    value: "Associate Degree, Computer Science & Business Administration",
  },
  {
    label: "Associate Degree in Audio/Video Production",
    value: "Associate Degree in Audio/Video Production",
  },
  {
    label: "Associate Degree in Liberal Arts & Science",
    value: "Associate Degree in Liberal Arts & Science",
  },
  {
    label: "Associate Degree, EEG (Electroencephalography)",
    value: "Associate Degree, EEG (Electroencephalography)",
  },
  {
    label: "Associate Degree of Technology, Electricity/Electronics",
    value: "Associate Degree of Technology, Electricity/Electronics",
  },
  {
    label: "Associate Degree, General Studies",
    value: "Associate Degree, General Studies",
  },
  {
    label: "Associate of Applied Science (ADN), Registered Nursing (RN)",
    value: "Associate of Applied Science (ADN), Registered Nursing (RN)",
  },
  {
    label: "Associate of Applied Science, Computer Information Systems",
    value: "Associate of Applied Science, Computer Information Systems",
  },
  { label: "Associate of Arts", value: "Associate of Arts" },
  {
    label: "Associate of Arts (A.A.), Architecture",
    value: "Associate of Arts (A.A.), Architecture",
  },
  {
    label:
      "Associate of Arts (A.A.), Film & TV: Production, 3.82 GPA (Overall)",
    value:
      "Associate of Arts (A.A.), Film & TV: Production, 3.82 GPA (Overall)",
  },
  {
    label:
      "Associate of Arts (A.A.), Liberal Arts and Sciences, General Studies and Humanities",
    value:
      "Associate of Arts (A.A.), Liberal Arts and Sciences, General Studies and Humanities",
  },
  {
    label:
      "Associate of Arts - AA, Business, Management, Marketing, and Related Support Services",
    value:
      "Associate of Arts - AA, Business, Management, Marketing, and Related Support Services",
  },
  {
    label: "Associate of Arts and Sciences (A.A.S.)",
    value: "Associate of Arts and Sciences (A.A.S.)",
  },
  {
    label: "Associate of Arts and Sciences (A.A.S.), Business Administration",
    value: "Associate of Arts and Sciences (A.A.S.), Business Administration",
  },
  {
    label: "Associate of Arts and Sciences (A.A.S.), Web Development",
    value: "Associate of Arts and Sciences (A.A.S.), Web Development",
  },
  {
    label: "Associate of Arts and Sciences (AAS) - Business Administration",
    value: "Associate of Arts and Sciences (AAS) - Business Administration",
  },
  {
    label: "Associate of Arts and Sciences (AAS), Computer Science",
    value: "Associate of Arts and Sciences (AAS), Computer Science",
  },
  {
    label:
      "Associate of Arts and Sciences (AAS), Computer Science - Cyber Security",
    value:
      "Associate of Arts and Sciences (AAS), Computer Science - Cyber Security",
  },
  {
    label: "Associate of Arts and Sciences (AAS), Data Processing",
    value: "Associate of Arts and Sciences (AAS), Data Processing",
  },
  {
    label: "Associate of Arts and Sciences (AAS), Information Technology",
    value: "Associate of Arts and Sciences (AAS), Information Technology",
  },
  {
    label: "Associate of Arts, Accounting",
    value: "Associate of Arts, Accounting",
  },
  {
    label: "Associate of Arts, Banking and Finance",
    value: "Associate of Arts, Banking and Finance",
  },
  {
    label: "Associate of Science (A.S.) Information Technology",
    value: "Associate of Science (A.S.) Information Technology",
  },
  {
    label: "Associate of Science (A.S.), Biology, General",
    value: "Associate of Science (A.S.), Biology, General",
  },
  {
    label: "Associate of Science (A.S.), Computer and Information Sciences",
    value: "Associate of Science (A.S.), Computer and Information Sciences",
  },
  {
    label: "Associate of Science (A.S.), Computer Engineering",
    value: "Associate of Science (A.S.), Computer Engineering",
  },
  {
    label:
      "Associate of Science (A.S.), Computer Engineering Technology/Technician, 3.0",
    value:
      "Associate of Science (A.S.), Computer Engineering Technology/Technician, 3.0",
  },
  {
    label:
      "Associate of Science (A.S.), Computer Information Systems, Management",
    value:
      "Associate of Science (A.S.), Computer Information Systems, Management",
  },
  {
    label: "Associate of Science (A.S.), Digital Media",
    value: "Associate of Science (A.S.), Digital Media",
  },
  { label: "Associate of Science - AS", value: "Associate of Science - AS" },
  {
    label: "Associate of Science - AS, Animation and Motion Graphics",
    value: "Associate of Science - AS, Animation and Motion Graphics",
  },
  {
    label: "Associate of Science, Business Administration",
    value: "Associate of Science, Business Administration",
  },
  {
    label: "Associate of Science, Design",
    value: "Associate of Science, Design",
  },
  {
    label: "Associate’s Degree, Business Administration and Management",
    value: "Associate’s Degree, Business Administration and Management",
  },
  {
    label: "Associate’s Degree, Diploma in Accounting & Finance",
    value: "Associate’s Degree, Diploma in Accounting & Finance",
  },
  {
    label: "Associate’s Degree, Accounting",
    value: "Associate’s Degree, Accounting",
  },
  {
    label: "Associate’s Degree, Chemical Engineering",
    value: "Associate’s Degree, Chemical Engineering",
  },
  {
    label: "Associate’s Degree, Civil Engineering Technology/Technician",
    value: "Associate’s Degree, Civil Engineering Technology/Technician",
  },
  {
    label: "Associate’s Degree, Computer and Information Sciences and Support",
    value: "Associate’s Degree, Computer and Information Sciences and Support",
  },
  {
    label: "Associate’s Degree, Computer Information Systems, 3.9",
    value: "Associate’s Degree, Computer Information Systems, 3.9",
  },
  {
    label: "Associate’s Degree, Computer Systems Networking and Administration",
    value: "Associate’s Degree, Computer Systems Networking and Administration",
  },
  {
    label:
      "Associate’s Degree, Computer Technology/Computer Systems Technology",
    value:
      "Associate’s Degree, Computer Technology/Computer Systems Technology",
  },
  {
    label: "Associate’s Degree, Computer/Information Technology Administration",
    value: "Associate’s Degree, Computer/Information Technology Administration",
  },
  {
    label: "Associate’s Degree, Culinary Arts and Related Services",
    value: "Associate’s Degree, Culinary Arts and Related Services",
  },
  {
    label: "Associate’s Degree, Data Processing",
    value: "Associate’s Degree, Data Processing",
  },
  {
    label: "Associate’s Degree, Database Management",
    value: "Associate’s Degree, Database Management",
  },
  {
    label: "Associate’s Degree, Digital Communication and Media/Multimedia",
    value: "Associate’s Degree, Digital Communication and Media/Multimedia",
  },
  {
    label: "Associate’s Degree, General Studies, 4.8",
    value: "Associate’s Degree, General Studies, 4.8",
  },
  {
    label: "Associate’s Degree, Information Technology",
    value: "Associate’s Degree, Information Technology",
  },
  {
    label:
      "Associate’s Degree, Information Technology - Computer Network Systems, 3.5 GPA",
    value:
      "Associate’s Degree, Information Technology - Computer Network Systems, 3.5 GPA",
  },
  {
    label: "Associate’s Degree, Liberal Arts and Sciences/Liberal Studies",
    value: "Associate’s Degree, Liberal Arts and Sciences/Liberal Studies",
  },
  {
    label:
      "Associate’s Degree, Mechanical Drafting and Pipe Drafting CAD/CADD, 2.9 GPA",
    value:
      "Associate’s Degree, Mechanical Drafting and Pipe Drafting CAD/CADD, 2.9 GPA",
  },
  {
    label: "Associate’s Degree, Network Specialist, 3.7",
    value: "Associate’s Degree, Network Specialist, 3.7",
  },
  {
    label: "Associate’s Degree, Specialized Business, 4.0",
    value: "Associate’s Degree, Specialized Business, 4.0",
  },
  {
    label:
      "Associate’s in Applied Science, Digital and Microprocessor Technology",
    value:
      "Associate’s in Applied Science, Digital and Microprocessor Technology",
  },
  {
    label: "Associate, Applied Business Computer Information Systems",
    value: "Associate, Applied Business Computer Information Systems",
  },
  {
    label: "Associate, Business Administration & Economics",
    value: "Associate, Business Administration & Economics",
  },
  {
    label: "Associate, Electronic Engineering",
    value: "Associate, Electronic Engineering",
  },
  { label: "Associate, Graphic Design", value: "Associate, Graphic Design" },
  { label: "Associates Degree", value: "Associates Degree" },
  {
    label: "Associates in Applied Science, Software Development Technology",
    value: "Associates in Applied Science, Software Development Technology",
  },
  {
    label: "Associates in Arts Degree, Business Administration",
    value: "Associates in Arts Degree, Business Administration",
  },
  { label: "Associates Not Completed", value: "Associates Not Completed" },
  {
    label: "Associates of Applied Science",
    value: "Associates of Applied Science",
  },
];

export const workAuthorizationOptions = [
  { label: "B1", value: "B1" },
  { label: "Bangladesh Authorized", value: "Bangladesh Authorized" },
  { label: "Brazil Authorized", value: "Brazil Authorized" },
  { label: "Can work for any employer", value: "Can work for any employer" },
  { label: "Canada Authorized", value: "Canada Authorized" },
  { label: "Canadian Citizen", value: "Canadian Citizen" },
  { label: "Canadian Citizenship", value: "Canadian Citizenship" },
  { label: "China Authorized", value: "China Authorized" },
  { label: "Citizen", value: "Citizen" },
  { label: "Colombia Authorized", value: "Colombia Authorized" },
  { label: "Current Employer Only", value: "Current Employer Only" },
  { label: "Employment Auth Document", value: "Employment Auth Document" },
  { label: "Employment Auth. Document", value: "Employment Auth. Document" },
  {
    label: "Employment Authorization Document",
    value: "Employment Authorization Document",
  },
  { label: "EU Eligible", value: "EU Eligible" },
  { label: "GC", value: "GC" },
  { label: "GC-EAD", value: "GC-EAD" },
  { label: "Germany Authorized", value: "Germany Authorized" },
  { label: "Green Card", value: "Green Card" },
  { label: "Green Card Holder", value: "Green Card Holder" },
  { label: "H1-B", value: "H1-B" },
  { label: "H4 EAD", value: "H4 EAD" },
  { label: "Have H1", value: "Have H1" },
  { label: "Have H1 Visa", value: "Have H1 Visa" },
  { label: "India Authorized", value: "India Authorized" },
  { label: "Ireland Authorized", value: "Ireland Authorized" },
  { label: "Italy Authorized", value: "Italy Authorized" },
  { label: "Kuwait Authorized", value: "Kuwait Authorized" },
  { label: "L1-A", value: "L1-A" },
  { label: "L1-B", value: "L1-B" },
  { label: "L2-EAD", value: "L2-EAD" },
  { label: "Luxembourg Authorized", value: "Luxembourg Authorized" },
  { label: "Macedonia Authorized", value: "Macedonia Authorized" },
  { label: "Mexico Authorized", value: "Mexico Authorized" },
  { label: "Need H1", value: "Need H1" },
  { label: "Need H1 Visa", value: "Need H1 Visa" },
  { label: "Need H1 Visa Sponsor", value: "Need H1 Visa Sponsor" },
  { label: "Not specified", value: "Not specified" },
  { label: "OPT-EAD", value: "OPT-EAD" },
  { label: "Pakistan Authorized", value: "Pakistan Authorized" },
  { label: "Poland Authorized", value: "Poland Authorized" },
  {
    label: "Russian Federation Authorized",
    value: "Russian Federation Authorized",
  },
  { label: "South Africa Authorized", value: "South Africa Authorized" },
  { label: "Sponsorship Required", value: "Sponsorship Required" },
  { label: "TN Permit Holder", value: "TN Permit Holder" },
  { label: "TN Visa", value: "TN Visa" },
  { label: "Turkey Authorized", value: "Turkey Authorized" },
  { label: "Ukraine Authorized", value: "Ukraine Authorized" },
  {
    label: "United Arab Emirates Authorized",
    value: "United Arab Emirates Authorized",
  },
  { label: "United Kingdom Authorized", value: "United Kingdom Authorized" },
  { label: "US Authorized", value: "US Authorized" },
  { label: "US Citizen", value: "US Citizen" },
  { label: "US Citizenship", value: "US Citizenship" },
];

export const CareerBuilderRadius = [
  { label: "0 Mile", value: "0" },
  { label: "1 Mile", value: "1" },
  { label: "2 Miles", value: "2" },
  { label: "3 Miles", value: "3" },
  { label: "4 Miles", value: "4" },
  { label: "5 Miles", value: "5" },
  { label: "10 Miles", value: "10" },
  { label: "15 Miles", value: "15" },
  { label: "20 Miles", value: "20" },
  { label: "25 Miles", value: "25" },
  { label: "30 Miles", value: "30" },
  { label: "40 Miles", value: "40" },
  { label: "50 Miles", value: "50" },
  { label: "75 Miles", value: "75" },
  { label: "100 Miles", value: "100" },
  { label: "125 Miles", value: "125" },
  { label: "150 Miles", value: "150" },
];

export const optionsMonsterPostFrom = [
  { label: "Today", value: 0 },
  { label: "1 day", value: 1440 },
  { label: "2 days", value: 2880 },
  { label: "3 days", value: 4320 },
  { label: "1 week", value: 8640 },
  { label: "2 weeks", value: 18720 },
  { label: "1 month", value: 41760 },
  { label: "3 months", value: 128160 },
  { label: "6 months", value: 257760 },
  { label: "9 months", value: 387360 },
];

export const optionsMonsterTo = [
  { label: "Today", value: 1440 },
  { label: "1 day", value: 2880 },
  { label: "2 days", value: 4320 },
  { label: "3 days", value: 5760 },
  { label: "1 week", value: 10080 },
  { label: "2 weeks", value: 20160 },
  { label: "1 month", value: 43200 },
  { label: "3 months", value: 129600 },
  { label: "6 months", value: 259200 },
  { label: "9 months", value: 388800 },
  { label: "All Resumes", value: 1576800 },
];

export const MonsterRadiusOptions = [
  { label: "5 miles away", value: 5 },
  { label: "10 miles away", value: 10 },
  { label: "20 miles away", value: 20 },
  { label: "30 miles away", value: 30 },
  { label: "40 miles away", value: 40 },
  { label: "50 miles away", value: 50 },
  { label: "60 miles away", value: 60 },
  { label: "75 miles away", value: 75 },
  { label: "100 miles away", value: 100 },
  { label: "150 miles away", value: 150 },
  { label: "200 miles away", value: 200 },
];

export const MonsterPowerSearchTravelRequirementsOptions = [
  { label: "No Travel Required", value: "1" },
  { label: "Up to 25% travel", value: "2" },
  { label: "Up to 50% travel", value: "3" },
  { label: "Up to 75% travel", value: "4" },
  { label: "Up to 100%", value: "5" },
];

export const MonsterPowerSearchTenureOptions = [
  { label: "1 year", value: "1" },
  { label: "2 years", value: "2" },
  { label: "5 years", value: "5" },
  { label: "10 years", value: "10" },
];

export const ClearanceLeveloptions = [
  { label: "Unspecified", value: 2 },
  { label: "Active Confodential", value: 3 },
  { label: "Active Secret", value: 4 },
  { label: "Active Top Secret", value: 5 },
  { label: "Active Top Secret/SCI", value: 6 },
  { label: "Active TS/SCI-CI Polygraph", value: 19 },
  { label: "Active TS/SCI-FS Polygraph", value: 20 },
  { label: "Other Active Clearance", value: 21 },
];

export const optionValuescitizen = [
  { label: "US Citizen", value: "164-1" },
  { label: "Parmanent Resident", value: "164-2" },
];

export const countryMonsterOptions = [
  { label: "United States", value: 840 },
  { label: "Canada", value: 124 },
];

export const statesArrayOptionMonster = [
  { label: "Alabama", value: 322 },
  { label: "Alaska", value: 317 },
  { label: "Arizona", value: 336 },
  { label: "Arkansas", value: 330 },
  { label: "California", value: 342 },
  { label: "Colorado", value: 360 },
  { label: "Connecticut", value: 366 },
  { label: "Delaware", value: 372 },
  { label: "District of Columbia", value: 696 },
  { label: "Florida", value: 376 },
  { label: "Georgia", value: 392 },
  { label: "Hawaii", value: 400 },
  { label: "Idaho", value: 411 },
  { label: "Illinois", value: 415 },
  { label: "Indiana", value: 425 },
  { label: "Iowa", value: 403 },
  { label: "Kansas", value: 432 },
  { label: "Kentucky", value: 438 },
  { label: "Louisiana", value: 444 },
  { label: "Maine", value: 461 },
  { label: "Maryland", value: 456 },
  { label: "Massachusetts", value: 452 },
  { label: "Michigan", value: 466 },
  { label: "Minnesota", value: 477 },
  { label: "Mississippi", value: 498 },
  { label: "Missouri", value: 486 },
  { label: "Montana", value: 504 },
  { label: "Nebraska", value: 524 },
  { label: "Nevada", value: 539 },
  { label: "New Hampshire", value: 683 },
  { label: "New Jersey", value: 682 },
  { label: "New Mexico", value: 536 },
  { label: "New York", value: 543 },
  { label: "North Carolina", value: 511 },
  { label: "North Dakota", value: 520 },
  { label: "Oklahoma", value: 568 },
  { label: "Oregon", value: 573 },
  { label: "Ohio", value: 557 },
  { label: "Pennsylvania", value: 580 },
  { label: "Rhode Island", value: 590 },
  { label: "South Carolina", value: 592 },
  { label: "South Dakota", value: 597 },
  { label: "Tennessee", value: 602 },
  { label: "Texas", value: 609 },
  { label: "Utah", value: 629 },
  { label: "Vermont", value: 642 },
  { label: "Virginia", value: 631 },
  { label: "Washington", value: 645 },
  { label: "West Virginia", value: 660 },
  { label: "Wisconsin", value: 650 },
  { label: "Wyoming", value: 666 },
  // { label: 'Puerto Rico', value: 315 },
  // { label: 'Virgin Islands', value: 641 },
  { label: "Armed Forces Americas", value: 32146 },
  { label: "Armed Forces Europe, the Middle East, and Canada", value: 32145 },
  { label: "Armed Forces Pacific", value: 32147 },
  { label: "Federated States of Micronesia", value: 54897 },
  // { label: 'Northern Mariana Islands', value: 54898 },
];

export const salaryTypeMonsterOptions = [
  { label: "Per Year", value: "1" },
  { label: "Per Hour", value: "2" },
  { label: "Per Week", value: "3" },
  { label: "Per Month", value: "4" },
  { label: "Biweekly", value: "5" },
  { label: "Per Day", value: "6" },
  { label: "Quarter", value: "7" },
  { label: "Other", value: "8" },
  { label: "Piece Rate", value: "9" },
];

export const MonsterEducationLevel = [
  { label: "Some High School Coursework", value: "12" },
  { label: "High School or equivalent", value: "1" },
  { label: "Certification", value: "2" },
  { label: "Vocational", value: "3" },
  { label: "Some College Coursework Completed", value: "9" },
  { label: "Associate Degree", value: "4" },
  { label: "Bachelor's Degree", value: "5" },
  { label: "Master's Degree", value: "6" },
  { label: "Doctorate", value: "7" },
  { label: "Professional", value: "8" },
];

export const LanguageskillsMonster = [
  { label: "Aboriginal Dialects", value: "1" },
  { label: "Afrikaans", value: "2" },
  { label: "American Sign Language", value: "3" },
  { label: "Ancient Greek", value: "4" },
  { label: "Arabic", value: "5" },
  { label: "Assamese", value: "6" },
  { label: "Australian Sign Language", value: "7" },
  { label: "Bahasa Indonesia", value: "8" },
  { label: "Basque", value: "9" },
  { label: "Bengali", value: "10" },
  { label: "Brazilian Portuguese", value: "11" },
  { label: "Breton", value: "12" },
  { label: "British Sign Language", value: "13" },
  { label: "Bulgarian", value: "14" },
  { label: "Burmese", value: "15" },
  { label: "Catalan", value: "16" },
  { label: "Chinese", value: "17" },
  { label: "Chinese - Cantonese", value: "18" },
  { label: "Chinese - Mandarin", value: "19" },
  { label: "Chinese - Taiwanese", value: "20" },
  { label: "Corsican", value: "21" },
  { label: "Croatian", value: "22" },
  { label: "Czech", value: "23" },
  { label: "Danish", value: "24" },
  { label: "Dutch", value: "25" },
  { label: "Egyptian", value: "26" },
  { label: "English", value: "27" },
  { label: "Estonian", value: "28" },
  { label: "Farsi", value: "29" },
  { label: "Finnish", value: "30" },
  { label: "French", value: "32" },
  { label: "Frisian", value: "33" },
  { label: "Gaelic", value: "34" },
  { label: "German", value: "35" },
  { label: "Greek", value: "36" },
  { label: "Greenlandic", value: "37" },
  { label: "Gujarati", value: "38" },
  { label: "Hebrew", value: "39" },
  { label: "Hindi", value: "40" },
  { label: "Hindustan", value: "41" },
  { label: "Hmong", value: "42" },
  { label: "Hungarian", value: "43" },
  { label: "Icelandic", value: "44" },
  { label: "Irish", value: "45" },
  { label: "Irish Gaelic", value: "46" },
  { label: "Italian", value: "47" },
  { label: "Japanese", value: "48" },
  { label: "Kannada", value: "49" },
  { label: "Kashmiri", value: "50" },
  { label: "Korean", value: "51" },
  { label: "Kurdish", value: "52" },
  { label: "Latin", value: "53" },
  { label: "Latvian", value: "54" },
  { label: "Lithuanian", value: "55" },
  { label: "Malay", value: "56" },
  { label: "Malayalam", value: "57" },
  { label: "Manipuri", value: "58" },
  { label: "Manx Gaelic", value: "59" },
  { label: "Maori", value: "60" },
  { label: "Marathi", value: "61" },
  { label: "Nepali", value: "62" },
  { label: "Norwegian", value: "63" },
  { label: "Oriya", value: "64" },
  { label: "Other", value: "65" },
  { label: "Polish", value: "66" },
  { label: "Portuguese", value: "67" },
  { label: "Prakrit", value: "68" },
  { label: "Punjabi", value: "69" },
  { label: "Romanian", value: "70" },
  { label: "Russian", value: "71" },
  { label: "Sanskrit", value: "72" },
  { label: "Scots", value: "73" },
  { label: "Scots Gaelic", value: "74" },
  { label: "Serbian", value: "75" },
  { label: "Sicilian", value: "76" },
  { label: "Slovak", value: "77" },
  { label: "Slovene", value: "78" },
  { label: "Spanish", value: "79" },
  { label: "Swahili", value: "80" },
  { label: "Swedish", value: "81" },
  { label: "Tagalog", value: "82" },
  { label: "Tamil", value: "83" },
  { label: "Telugu", value: "84" },
  { label: "Thai", value: "85" },
  { label: "Tibetan", value: "86" },
  { label: "Turkish", value: "87" },
  { label: "Ukrainian", value: "88" },
  { label: "Urdu", value: "89" },
  { label: "Vietnamese", value: "90" },
  { label: "Welsh", value: "91" },
  { label: "Yiddish", value: "92" },
  { label: "Ainu", value: "93" },
  { label: "Akkadian", value: "94" },
  { label: "Alurian", value: "95" },
  { label: "Arkian", value: "96" },
  { label: "Assyrian", value: "97" },
  { label: "Asturian", value: "98" },
  { label: "Aymara", value: "99" },
  { label: "Basque Language-Euskara", value: "100" },
  { label: "Berber", value: "101" },
  { label: "Buhi", value: "102" },
  { label: "Cherokee", value: "103" },
  { label: "Chichewa", value: "104" },
  { label: "Church Slavonic", value: "105" },
  { label: "Cornish", value: "106" },
  { label: "Dakota", value: "107" },
  { label: "Degaspregos", value: "108" },
  { label: "Dilhok", value: "109" },
  { label: "Dongxiang", value: "110" },
  { label: "Esperanto", value: "111" },
  { label: "Eurolang", value: "112" },
  { label: "Faroese", value: "113" },
  { label: "Friulian", value: "114" },
  { label: "Galician", value: "115" },
  { label: "Georgian", value: "116" },
  { label: "Guarani", value: "117" },
  { label: "Haponish", value: "118" },
  { label: "Hausa", value: "119" },
  { label: "Hawaiian", value: "120" },
  { label: "Hawaiian Pidgin English", value: "121" },
  { label: "Ido", value: "122" },
  { label: "Ingush", value: "123" },
  { label: "Interlingua", value: "124" },
  { label: "Irish", value: "125" },
  { label: "Kijawi", value: "126" },
  { label: "Kinyarwanda", value: "127" },
  { label: "Kirghiz", value: "128" },
  { label: "Kuku-Yalanji", value: "129" },
  { label: "Lao", value: "130" },
  { label: "Lingala", value: "131" },
  { label: "Lithuanian", value: "132" },
  { label: "Low German", value: "133" },
  { label: "Luxembourgish", value: "134" },
  { label: "Macedonian", value: "135" },
  { label: "Malagasy", value: "136" },
  { label: "Maltese", value: "137" },
  { label: "Māori", value: "138" },
  { label: "Masai", value: "139" },
  { label: "Minangkabau", value: "140" },
  { label: "Mizoram", value: "141" },
  { label: "Mongolian", value: "142" },
  { label: "Nahuatl", value: "143" },
  { label: "Navajo", value: "144" },
  { label: "Ndebele", value: "145" },
  { label: "Nigerian Pidgin", value: "146" },
  { label: "Pashto", value: "147" },
  { label: "Persian", value: "148" },
  { label: "Quechua", value: "149" },
  { label: "Quechua Language", value: "150" },
  { label: "Romanian", value: "151" },
  { label: "Sango", value: "152" },
  { label: "Sardinian", value: "153" },
  { label: "Serbo-Croatian", value: "154" },
  { label: "Sesotho", value: "155" },
  { label: "Sinhalese", value: "156" },
  { label: "Somali", value: "157" },
  { label: "Sotho", value: "158" },
  { label: "Spanish", value: "159" },
  { label: "Swahili", value: "160" },
  { label: "Tajik", value: "161" },
  { label: "Tigrinya", value: "162" },
  { label: "Tigrinya Language", value: "163" },
  { label: "Tok Pisin", value: "164" },
  { label: "Twi", value: "165" },
  { label: "Uighur", value: "166" },
  { label: "Ukrainian", value: "167" },
  { label: "Uzbek", value: "168" },
  { label: "Warlpiri", value: "169" },
  { label: "Welsh", value: "170" },
  { label: "Xhosa", value: "171" },
  { label: "Yoruba", value: "172" },
  { label: "Zulu", value: "173" },
];

export const careerLevelOptions = [
  { label: "Select All", value: "Select All" },
  { label: "Student (High School)", value: "Student (High School)" },
  { label: "Entry Level", value: "Entry Level" },
  { label: "Experienced (Non-Manager)", value: "Experienced (Non-Manager)" },
  {
    label: "Manager (Manager/Supervisor of Staff)",
    value: "Manager (Manager/Supervisor of Staff)",
  },
  {
    label: "Executive (SVP, VP, Department Head, etc)",
    value: "Executive (SVP, VP, Department Head, etc)",
  },
  {
    label: "Senior Executive (President, CFO, etc)",
    value: "Senior Executive (President, CFO, etc)",
  },
];

export const careerMonsterLevelOptions = [
  { label: "Executive Level", value: 2 },
  { label: "Vice President", value: 1 },
  { label: "Director", value: 5 },
  { label: "Manager", value: 7 },
  { label: "Representative", value: 11 },
];

export const MonsterSearchResumeUpdatedOptions = [
  { label: "All Resumes", value: 0 },
  { label: "Today", value: 1 },
  { label: "within 1 day", value: 2 },
  { label: "within 2 days", value: 3 },
  { label: "within 3 days", value: 4 },
  { label: "within 1 week", value: 7 },
  { label: "within 1 month", value: 30 },
  { label: "within 3 months", value: 90 },
  { label: "within 6 months", value: 180 },
  { label: "within 9 months", value: 270 },
  { label: "within 12 months", value: 365 },
  { label: "within 24 months", value: 730 },
  { label: "within 36 months", value: 1095 },
];

export const ProfessionalLevelMonsterOptions = [
  { label: "Beginner", value: "1" },
  { label: "Intermediate", value: "3" },
  { label: "Advanced", value: "5" },
  { label: "Fluent", value: "6" },
  { label: "Unknown", value: "0" },
];

export const indusriesMonsterOptions = [
  { label: "Agriculture/Forestry/Fishing", value: "1" },
  { label: "Metals and Minerals", value: "2" },
  { label: "Energy and Utilities", value: "3" },
  {
    label: "Construction - Industrial Facilities and Infrastructure",
    value: "4",
  },
  { label: "Trade Contractors", value: "5" },
  { label: "Aerospace and Defense", value: "6" },
  { label: "Automotive and Parts Mfg", value: "7" },
  { label: "Biotechnology/Pharmaceuticals", value: "8" },
  { label: "Chemicals/Petro-Chemicals", value: "9" },
  { label: "Consumer Packaged Goods Manufacturing", value: "10" },
  { label: "Electronics, Components, and Semiconductor Mfg", value: "11" },
  { label: "Manufacturing - Other", value: "12" },
  { label: "Printing and Publishing", value: "13" },
  { label: "Clothing and Textile Manufacturing", value: "14" },
  { label: "Wholesale Trade/Import-Export", value: "15" },
  { label: "Grocery/Convenience/Gas", value: "16" },
  { label: "Retail", value: "17" },
  { label: "Travel, Transportation and Tourism", value: "18" },
  { label: "Transport and Storage - Materials", value: "19" },
  { label: "Internet Services", value: "20" },
  { label: "Broadcasting, Music, and Film", value: "21" },
  { label: "Telecommunications Services", value: "22" },
  { label: "Banking", value: "23" },
  { label: "Insurance", value: "24" },
  { label: "Mortgage", value: "25" },
  { label: "Real Estate/Property Management", value: "26" },
  { label: "Rental Services", value: "27" },
  { label: "Accounting and Auditing Services", value: "28" },
  { label: "Advertising and PR Services", value: "29" },
  { label: "Architectural and Design Services", value: "30" },
  { label: "Management Consulting Services", value: "31" },
  { label: "Computer Hardware", value: "32" },
  { label: "Computer Software", value: "33" },
  { label: "Legal Services", value: "34" },
  { label: "Management and Holding Companies", value: "35" },
  { label: "Administrative and Support Services", value: "36" },
  { label: "Waste Management", value: "37" },
  { label: "Education", value: "38" },
  { label: "Healthcare Services", value: "39" },
  { label: "Nursing/Residential Care Facilities", value: "40" },
  { label: "Social Services", value: "41" },
  { label: "Performing and Fine Arts", value: "42" },
  { label: "Sports and Physical Recreation", value: "43" },
  { label: "Hotels and Lodging", value: "44" },
  { label: "Restaurant/Food Services", value: "45" },
  { label: "Staffing/Employment Agencies", value: "46" },
  { label: "Nonprofit Charitable Organizations", value: "47" },
  { label: "Personal and Household Services", value: "48" },
  { label: "Repair and Maintenance Services", value: "49" },
  { label: "Government and Military", value: "50" },
  { label: "Government- Military/Defense", value: "51" },
  { label: "Government- National", value: "52" },
  { label: "Security and Surveillance", value: "74" },
  { label: "Automotive Sales and Repair Services", value: "75" },
  { label: "Business Services - Other", value: "76" },
  { label: "Computer/IT Services", value: "77" },
  { label: "Construction - Residential & Commercial/Office", value: "78" },
  { label: "Engineering Services", value: "79" },
  { label: "Entertainment Venues and Theaters", value: "80" },
  { label: "Financial Services", value: "81" },
  { label: "Food and Beverage Production", value: "82" },
  { label: "Marine Mfg & Services", value: "83" },
  { label: "Medical Devices and Supplies", value: "84" },
  { label: "Other/Not Classified", value: "85" },
];

export const radiusOptionsMonsterIntegrateSearch = [
  // { label: "Select", value: "" },
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "30", value: 30 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
];

export const lastUpdatedOptionsIntegrateSearch = [
  { label: "Select", value: "" },
  { label: "7 Days", value: 7 },
  { label: "30 Days", value: 30 },
  { label: "90 Days", value: 90 },
  { label: "All Resumes", value: 999 },
];

export const workAuthorizationIntegrationSearch = [
  { label: "B1", value: "b1" },
  { label: "Bangladesh Authorized", value: "bangladesh authorized" },
  { label: "Brazil Authorized", value: "brazil authorized" },
  { label: "Can work for any employer", value: "can work for any employer" },
  { label: "Canada Authorized", value: "canada authorized" },
  { label: "Canadian Citizen", value: "canadian citizen" },
  { label: "Canadian Citizenship", value: "canadian citizenship" },
  { label: "China Authorized", value: "china authorized" },
  { label: "Citizen", value: "citizen" },
  { label: "Colombia Authorized", value: "colombia authorized" },
  { label: "Current Employer Only", value: "current employer only" },
  { label: "Employment Auth Document", value: "employment auth document" },
  { label: "Employment Auth. Document", value: "employment auth. document" },
  {
    label: "Employment Authorization Document",
    value: "employment authorization document",
  },
  { label: "EU Eligible", value: "eu eligible" },
  { label: "GC", value: "gc" },
  { label: "GC-EAD", value: "gc-ead" },
  { label: "Germany Authorized", value: "germany authorized" },
  { label: "Green Card", value: "green card" },
  { label: "Green Card Holder", value: "green card holder" },
  { label: "H1-B", value: "h1-b" },
  { label: "H4 EAD", value: "h4 ead" },
  { label: "Have H1", value: "have h1" },
  { label: "Have H1 Visa", value: "have h1 visa" },
  { label: "India Authorized", value: "india authorized" },
  { label: "Ireland Authorized", value: "ireland authorized" },
  { label: "Italy Authorized", value: "italy authorized" },
  { label: "Kuwait Authorized", value: "kuwait authorized" },
  { label: "L1-A", value: "l1-a" },
  { label: "L1-B", value: "l1-b" },
  { label: "L2-EAD", value: "l2-ead" },
  { label: "Luxembourg Authorized", value: "luxembourg authorized" },
  { label: "Macedonia Authorized", value: "macedonia authorized" },
  { label: "Mexico Authorized", value: "mexico authorized" },
  { label: "Need H1", value: "need h1" },
  { label: "Need H1 Visa", value: "need h1 visa" },
  { label: "Need H1 Visa Sponsor", value: "need h1 visa sponsor" },
  { label: "Not specified", value: "not specified" },
  { label: "OPT-EAD", value: "opt-ead" },
  { label: "Pakistan Authorized", value: "pakistan authorized" },
  { label: "Poland Authorized", value: "poland authorized" },
  {
    label: "Russian Federation Authorized",
    value: "russian federation authorized",
  },
  { label: "South Africa Authorized", value: "south africa authorized" },
  { label: "Sponsorship Required", value: "sponsorship required" },
  { label: "TN Permit Holder", value: "tn permit holder" },
  { label: "TN Visa", value: "tn visa" },
  { label: "Turkey Authorized", value: "turkey authorized" },
  { label: "Ukraine Authorized", value: "ukraine authorized" },
  {
    label: "United Arab Emirates Authorized",
    value: "united arab emirates authorized",
  },
  { label: "United Kingdom Authorized", value: "united kingdom authorized" },
  { label: "US Authorized", value: "us authorized" },
  { label: "US Citizen", value: "us citizen" },
  { label: "US Citizenship", value: "us citizenship" },
  { label: "CTCT", value: "ctct" },
  { label: "CTEM", value: "ctem" },
  { label: "EAEA", value: "eaea" },
];

export const careerLevelMonster = [
  { label: "Student (High School)", value: "10" },
  { label: "Entry Level", value: "11" },
  { label: "Experienced (Non-Manager)", value: "12" },
  { label: "Manager (Manager/Supervisor of Staff)", value: "13" },
  { label: "Executive (SVP, VP, Department Head, etc)", value: "14" },
  { label: "Senior Executive (President, CFO, etc)", value: "15" },
];

export const reportPeriodOptions = [
  { label: "All Dates", value: 1 },
  { label: "Custom Dates", value: 2 },
  { label: "Today", value: 3 },
  { label: "This Week", value: 4 },
  { label: "This Month", value: 5 },
  { label: "Quarter 1", value: 6 },
  { label: "Quarter 2", value: 7 },
  { label: "Quarter 3", value: 8 },
  { label: "Quarter 4", value: 9 },
  { label: "Last Year", value: 10 },
];
export const predefinedDatePickerOptions = [
  { label: "Today", value: 1 },
  { label: "Yesterday", value: 2 },
  { label: "This Week", value: 3 },
  { label: "Last Week", value: 4 },
  { label: "This Month", value: 6 },
  { label: "Last Month", value: 7 },
  { label: "This Year", value: 10 },
  { label: "Custom Dates", value: 12 },
];
export const datePickerOptions = [
  { label: "Today", value: 1 },
  { label: "Yesterday", value: 2 },
  { label: "This Week", value: 3 },
  { label: "Last Week", value: 4 },
  { label: "FortNight", value: 5 },
  { label: "This Month", value: 6 },
  { label: "Last Month", value: 7 },
  { label: "Last 3 Months", value: 8 },
  { label: "Last 6 Months", value: 9 },
  { label: "This Year", value: 10 },
  { label: "Last Year", value: 11 },
  { label: "Custom Dates", value: 12 },
];
export const singleDatePickerOptions = [
  { label: "Today", value: 13 },
  { label: "Yesterday", value: 14 },
  { label: "Custom Dates", value: 12 },
];
export const usStateOptions = [
  { label: "Alabama", value: "alabama" },
  { label: "Alaska", value: "alaska" },
  { label: "Arizona", value: "arizona" },
  { label: "Arkansas", value: "arkansas" },
  { label: "California", value: "california" },
  { label: "Colorado", value: "colorado" },
  { label: "Connecticut", value: "connecticut" },
  { label: "Delaware", value: "delaware" },
  { label: "Florida", value: "florida" },
  { label: "Georgia", value: "georgia" },
  { label: "Hawaii", value: "hawaii" },
  { label: "Idaho", value: "idaho" },
  { label: "Illinois", value: "illinois" },
  { label: "Indiana", value: "indiana" },
  { label: "Iowa", value: "iowa" },
  { label: "Kansas", value: "kansas" },
  { label: "Kentucky", value: "kentucky" },
  { label: "Louisiana", value: "louisiana" },
  { label: "Maine", value: "maine" },
  { label: "Maryland", value: "maryland" },
  { label: "Massachusetts", value: "massachusetts" },
  { label: "Michigan", value: "michigan" },
  { label: "Minnesota", value: "minnesota" },
  { label: "Mississippi", value: "mississippi" },
  { label: "Missouri", value: "missouri" },
  { label: "Montana", value: "montana" },
  { label: "Nebraska", value: "nebraska" },
  { label: "Nevada", value: "nevada" },
  { label: "New Hampshire", value: "new hampshire" },
  { label: "New Jersey", value: "new jersey" },
  { label: "New Mexico", value: "new mexico" },
  { label: "New York", value: "new york" },
  { label: "North Carolina", value: "north carolina" },
  { label: "North Dakota", value: "north dakota" },
  { label: "Ohio", value: "ohio" },
  { label: "Oklahoma", value: "oklahoma" },
  { label: "Oregon", value: "oregon" },
  { label: "Pennsylvania", value: "pennsylvania" },
  { label: "Rhode Island", value: "rhode island" },
  { label: "South Carolina", value: "south carolina" },
  { label: "South Dakota", value: "south dakota" },
  { label: "Tennessee", value: "tennessee" },
  { label: "Texas", value: "texas" },
  { label: "Utah", value: "utah" },
  { label: "Vermont", value: "vermont" },
  { label: "Virginia", value: "virginia" },
  { label: "Washington", value: "washington" },
  { label: "West Virginia", value: "west virginia" },
  { label: "Wisconsin", value: "wisconsin" },
  { label: "Wyoming", value: "wyoming" }
];


export const carrerbuilderJobCategories = [
  { label: "Accounting", value: "JN001" },
  { label: "Admin - Clerical", value: "JN002" },
  { label: "Automotive", value: "JN054" },
  { label: "Banking", value: "JN038" },
  { label: "Biotech", value: "JN053" },
  { label: "Business Development", value: "JN019" },
  { label: "Business Opportunity", value: "JN059" },
  { label: "Construction", value: "JN043" },
  { label: "Consultant", value: "JN020" },
  { label: "Customer Service", value: "JN003" },
  { label: "Design", value: "JN021" },
  { label: "Distribution - Shipping", value: "JN027" },
  { label: "Education", value: "JN031" },
  { label: "Engineering", value: "JN004" },
  { label: "Entry Level", value: "JN022" },
  { label: "Executive", value: "JN018" },
  { label: "Facilities", value: "JN017" },
  { label: "Finance", value: "JN005" },
  { label: "Franchise", value: "JN060" },
  { label: "General Business", value: "JN006" },
  { label: "General Labor", value: "JN051" },
  { label: "Government", value: "JN046" },
  { label: "Government - Federal", value: "JN070" },
  { label: "Grocery", value: "JN055" },
  { label: "Health Care", value: "JN023" },
  { label: "Hospitality - Hotel", value: "JN040" },
  { label: "Human Resources", value: "JN007" },
  { label: "Information Technology", value: "JN008" },
  { label: "Installation - Maint - Repair", value: "JN056" },
  { label: "Insurance", value: "JN034" },
  { label: "Inventory", value: "JN015" },
  { label: "Legal", value: "JN030" },
  { label: "Legal Admin", value: "JN041" },
  { label: "Management", value: "JN037" },
  { label: "Manufacturing", value: "JN029" },
  { label: "Marketing", value: "JN009" },
  { label: "Media - Journalism - Newspaper", value: "JN047" },
  { label: "Nonprofit - Social Services", value: "JN058" },
  { label: "Nurse", value: "JN050" },
  { label: "Other", value: "JN010" },
  { label: "Pharmaceutical", value: "JN049" },
  { label: "Professional Services", value: "JN024" },
  { label: "Purchasing - Procurement", value: "JN016" },
  { label: "QA - Quality Control", value: "JN025" },
  { label: "Real Estate", value: "JN057" },
  { label: "Research", value: "JN026" },
  { label: "Restaurant - Food Service", value: "JN035" },
  { label: "Retail", value: "JN033" },
  { label: "Sales", value: "JN011" },
  { label: "Science", value: "JN012" },
  { label: "Skilled Labor - Trades", value: "JN013" },
  { label: "Strategy - Planning", value: "JN028" },
  { label: "Supply Chain", value: "JN014" },
  { label: "Telecommunications", value: "JN048" },
  { label: "Training", value: "JN032" },
  { label: "Transportation", value: "JN044" },
  { label: "Veterinary Services", value: "JN069" },
  { label: "Warehouse", value: "JN045" },
];

export const RelocationfilterOptionsCareerBuilder = [
  { label: "Relocate to Specified State", value: "RS" },
  { label: "Relocate to Specified City", value: "RC" },
  { label: "Relocate to Specified Nation", value: "RN" },
  { label: "Relocate to Any Location", value: "RA" },
];
export const IndustryOptions = [
  { label: "Agriculture and Allied Industries", value: "1" },
  { label: "Auto Components", value: "2" },
  { label: "Auto Mobile", value: "3" },
  { label: "Aviation", value: "4" },
  { label: "Banking", value: "5" },
  { label: "Bio Technology", value: "6" },
  { label: "Cement chemicals", value: "7" },
  { label: "Consumer Durables", value: "8" },
  { label: "Defence Manufactoring", value: "9" },
  { label: "Educational and Training", value: "10" },
  { label: "Electrical System Design and manufacturing", value: "11" },
  { label: "Engineering and Capital Goods", value: "12" },
  { label: "FMCG", value: "13" },
  { label: "Financial Services", value: "14" },
  { label: "Gems and jewelry", value: "15" },
  { label: "Health Care", value: "16" },
  { label: "IT & BPM", value: "17" },
  { label: "Infrastructure", value: "18" },
  { label: "MSME", value: "19" },
  { label: "Manufacturing", value: "20" },
  { label: "Media and entertainment", value: "21" },
  { label: "Medical Devices", value: "22" },
  { label: "Metals and Mining", value: "23" },
  { label: "Oils and gas", value: "24" },
  { label: "Pharmaceuticals", value: "25" },
  { label: "Ports", value: "26" },
  { label: "Renewable Energy", value: "27" },
  { label: "Retail", value: "28" },
  { label: "Roads", value: "29" },
  { label: "Science and Technology", value: "30" },
  { label: "Services", value: "31" },
  { label: "Steel", value: "32" },
  { label: "Telecommunication", value: "33" },
  { label: "Textiles", value: "34" },
  { label: "Tourism and Hospitality", value: "35" },
];

export const careerBuilderRadius = [
  { label: "0 Mile", value: "0" },
  { label: "1 Mile", value: "1" },
  { label: "2 Miles", value: "2" },
  { label: "3 Miles", value: "3" },
  { label: "4 Miles", value: "4" },
  { label: "5 Miles", value: "5" },
  { label: "10 Miles", value: "10" },
  { label: "15 Miles", value: "15" },
  { label: "20 Miles", value: "20" },
  { label: "25 Miles", value: "25" },
  { label: "30 Miles", value: "30" },
  { label: "40 Miles", value: "40" },
  { label: "50 Miles", value: "50" },
  { label: "75 Miles", value: "75" },
  { label: "100 Miles", value: "100" },
  { label: "125 Miles", value: "125" },
  { label: "150 Miles", value: "150" },
];

export const freshnessInDaysOptionsCareerBuilder = [
  { label: "Today", value: "0" },
  { label: "yesterday", value: "1" },
  { label: "last 7 days", value: "7" },
  { label: "last 30 days", value: "30" },
  { label: "last 90 days", value: "90" },
  { label: "last 180 days", value: "180" },
  { label: "last 270 days", value: "270" },
  { label: "last year", value: "365" },
  { label: "last 3 years", value: "1095" },
  { label: "last 5 years", value: "1825" },
  { label: "last 10 years", value: "3650" },
  { label: "last 15 years", value: "5475" },
  { label: "last 20 years", value: "7300" },
];

export const employmentTypeOptionsCareerBuilder = [
  { label: "All combinations", value: "All" },
  { label: "Full-Time employee", value: "ETFE" },
  { label: "Part-Time employee", value: "ETPE" },
  { label: "Contractror", value: "ETCT" },
  { label: "Intern", value: "ETIN" },
];

export const minimumTravelRequirementOptionsCareerBuilder = [
  { label: "NONE", value: "RTNONE" },
  { label: "Neglibile", value: "RT3210" },
  { label: "up to 25%", value: "RT321" },
  { label: "up to 50%", value: "TR32" },
  { label: "ROad wrrior", value: "RT" },
];

export const minimumDegreeOptionsCareerBuilder = [
  { label: "High school", value: "CE31" },
  { label: "2YEAR degree", value: "CE32" },
  { label: "4YEAR degree", value: "CE321" },
  { label: "Graduate degree", value: "CE3210" },
];

export const compensationTypeOptionsCareerBuilder = [
  { label: "salary", value: "SALR" },
  { label: "Hourly", value: "HOUR" },
];

export const excludeResumesWithNoSalaryOptionsCareerBuilder = [
  { label: "Yes", value: "Yes" },
  { label: "NO", value: "No" },
];

export const languagesSpokenOptionsCareerBuilder = [
  { label: "English", value: "LAEN" },
  { label: "Catalán", value: "LACA" },
  { label: "Chinese-Mandarin", value: "LAZH" },
  { label: "Czech", value: "LACS" },
  { label: "Danish", value: "LADA" },
  { label: "Dutch", value: "LANL" },
  { label: "Estonian", value: "LAET" },
  { label: "Euskera", value: "LAEU" },
  { label: "Finnish", value: "LAFI" },
  { label: "French", value: "LAFR" },
  { label: "German", value: "LADE" },
  { label: "Greek", value: "LAEL" },
  { label: "Hebrew", value: "LAHE" },
  { label: "Hungarian", value: "LAHU" },
  { label: "Icelandic", value: "LAIS" },
  { label: "Italian", value: "LAIT" },
  { label: "Japanese", value: "LAJA" },
  { label: "Korean", value: "LAKO" },
  { label: "Latvian", value: "LALV" },
  { label: "Lithuanian", value: "LALT" },
  { label: "Norwegian", value: "LANO" },
  { label: "Polish", value: "LAPL" },
  { label: "Spanish", value: "LAES" },
  { label: "Portuguese", value: "LAPT" },
  { label: "Romanian", value: "LARO" },
  { label: "Russian", value: "LARU" },
  { label: "Swedish", value: "LASV" },
  { label: "Arabic", value: "LAAR" },
  { label: "Bengali", value: "LABN" },
  { label: "Chinese-Cantonese", value: "LAHK" },
  { label: "Chinese-Taiwanese", value: "LATW" },
  { label: "Hindi", value: "LAHI" },
  { label: "Urdu", value: "LAUR" },
  { label: "Armenian", value: "LAHY" },
  { label: "Assamese", value: "LAAS" },
  { label: "Farsi", value: "LAFO" },
  { label: "Gujarati", value: "LAGU" },
  { label: "Kannada", value: "LAKN" },
  { label: "Kashmiri", value: "LAKS" },
  { label: "Malayalam", value: "LAML" },
  { label: "Oriya", value: "LAOR" },
  { label: "Pashto", value: "LAPS" },
  { label: "Punjabi", value: "LAPA" },
  { label: "Sanskrit", value: "LASA" },
  { label: "Sindhi", value: "LASD" },
  { label: "Tamil", value: "LATA" },
  { label: "Telugu", value: "LATE" },
  { label: "Turkish", value: "LATR" },
  { label: "Uzbek", value: "LAUZ" },
  { label: "Indonesian", value: "LAFJ" },
  { label: "Vasco", value: "LAVA" },
  { label: "Bulgarian", value: "LABU" },
  { label: "Croatian", value: "LACR" },
  { label: "Macedonian", value: "LAMC" },
  { label: "Serbian", value: "LASB" },
  { label: "Albanian", value: "LASQ" },
  { label: "Cambodian", value: "LACM" },
  { label: "Chinese-Chinois", value: "LACH" },
  { label: "Ukranian", value: "LAKR" },
  { label: "Vietnamese", value: "LAVT" },
];

export const militeryexperienceOptionsCareerBuilder = [
  { label: "Active Duty", value: "M1" },
  { label: "Reservist-Drilling", value: "M2" },
  { label: "National Guard-Drilling", value: "M3" },
  { label: "Inactive Reserve", value: "M4" },
  { label: "Inactive National Guard", value: "M5" },
  { label: "Retired Military", value: "M6" },
  { label: "Veteran", value: "M7" },
];

export const carrerbuilderkilometers = [
  { label: "0 km", value: "0" },
  { label: "1 km", value: "1" },
  { label: "2 km", value: "2" },
  { label: "3 km", value: "3" },
  { label: "4 km", value: "4" },
  { label: "5 km", value: "5" },
  { label: "10 km", value: "10" },
  { label: "15 km", value: "15" },
  { label: "20 km", value: "20" },
  { label: "25 km", value: "25" },
  { label: "30 km", value: "30" },
  { label: "40 km", value: "40" },
  { label: "50 km", value: "50" },
  { label: "75 km", value: "75" },
  { label: "100 km", value: "100" },
  { label: "125 km", value: "125" },
  { label: "150 km", value: "150" },
];

export const carrerbuilderapplyLastActivity = [
  { label: "Midnight-Present", value: "0" },
  { label: "Since Yesterday", value: "1" },
  { label: "Last 7 Days", value: "7" },
  { label: "Last 30 Days", value: "30" },
  { label: "Last 90 Days", value: "90" },
  { label: "Last 180 Days", value: "180" },
  { label: "Last 270 Days", value: "270" },
  { label: "Last Year", value: "365" },
];

export const carrerbuildersearchWithMostRecentCompany = [
  { label: "Include Most Recent Company", value: "True" },
  { label: "Exclude Most Recent Company", value: "False" },
];

export const lemmatizeOptionsCareerBuilder = [
  { label: "Do not use lemmatization", value: "False" },
  { label: "Use lemmatization", value: "True" },
];

export const workStatusOptionsCB = [
  { label: "Can work for any employer", value: "CTAY" },
  { label: "US Citizen", value: "CTCT" },
  { label: "H1 Visa", value: "CTEM" },
  { label: "Green Card Holder", value: "CTGR" },
  { label: "Need H1 Visa Sponsor", value: "CTNO" },
  { label: "TN Permit Holder", value: "EATN" },
  { label: "Employment Authorization Document", value: "EAEA" },
  { label: "Not specified", value: "CTNS" },
];
export const yearsOfExperienceOptionsCB = [
  { label: "Select", value: "" },
  { label: "0 yrs", value: 0 },
  { label: "1 yr", value: 1 },
  { label: "2 yrs", value: 2 },
  { label: "3 yrs", value: 3 },
  { label: "4 yrs", value: 4 },
  { label: "5 yrs", value: 5 },
  { label: "6 yrs", value: 6 },
  { label: "7 yrs", value: 7 },
  { label: "8 yrs", value: 8 },
  { label: "9 yrs", value: 9 },
  { label: "10 yrs", value: 10 },
  { label: "11 yrs", value: 11 },
  { label: "12 yrs", value: 12 },
  { label: "13 yrs", value: 13 },
  { label: "14 yrs", value: 14 },
  { label: "15 yrs", value: 15 },
  { label: "16 yrs", value: 16 },
  { label: "17 yrs", value: 17 },
  { label: "18 yrs", value: 18 },
  { label: "19 yrs", value: 19 },
  { label: "20 yrs", value: 20 }
];

export const resumeModifiedOptionsCB = [
  { label: "Select", value: "" },
  { label: "0 week", value: 0 },
  { label: "1 week", value: 7 },
  { label: "2 weeks", value: 14 },
  { label: "3 weeks", value: 21 },
  { label: "4 weeks", value: 28 },
  { label: "2 months", value: 56 },
  { label: "3 months", value: 84 },
  { label: "6 months", value: 168 },
  { label: "1 Year", value: 364 },
  { label: "2 Years", value: 728 },
];
export const resumeModifiedToOptionsCB = [
  { label: "Select", value: "" },
  { label: "0 week", value: 0 },
  { label: "1 week", value: 7 },
  { label: "2 weeks", value: 14 },
  { label: "3 weeks", value: 21 },
  { label: "4 weeks", value: 28 },
  { label: "2 months", value: 56 },
  { label: "3 months", value: 84 },
  { label: "6 months", value: 168 },
  { label: "1 Year", value: 364 },
  { label: "2 Years", value: 728 },
  { label: "2+ Years", value: 10 },
];

export const careerBuilderEmploymentClassification = [
  { label: "Full-Time", value: "Full-Time" },
  { label: "Part-Time", value: "Part-Time" },
  { label: "Temporary", value: "Temporary" },
  { label: "Contract", value: "Contract" },
  { label: "Internship", value: "Internship" },
  { label: "Seasonal", value: "Seasonal" },
  { label: "Per Diem", value: "Per Diem" },
];

export const monsterTwlidOptions = [
  {
    label: "Include Job Seekers Employable in Any of the Selected Locations.",
    value: "Include Job Seekers Employable in Any of the Selected Locations.",
  },
];

export const monsterWaOptions = [
  {
    label:
      "Include Job Seekers Authorized to Work for any Employer in Any of the Selected Locations.",
    value:
      "Include Job Seekers Authorized to Work for any Employer in Any of the Selected Locations.",
  },
];

export const onboardingStatus = [
  {
    label: "Pending",
    value: 1,
  },
  {
    label: "Draft",
    value: 2,
  },
  {
    label: "Initiated",
    value: 3,
  },
  {
    label: "Responded",
    value: 4,
  },
  {
    label: "Verified",
    value: 5,
  },
  {
    label: "Negotiate",
    value: 6,
  },
  {
    label: "Joined",
    value: 7,
  },
  {
    label: "Disqualified",
    value: 8,
  },
  {
    label: "Cancelled",
    value: 9,
  },
];

export const documentOnboardingStatus = [
  {
    label: "Initiated",
    value: 1,
    color: "green",
  },
  {
    label: "Responded",
    value: 2,
    color: "primary",
  },
  {
    label: "Verified",
    value: 3,
    color: "success",
  },
  {
    label: "Rejected",
    value: 4,
    color: "red",
  },
  {
    label: "Wish To Discuss",
    value: 5,
    color: "success",
  },
];

export const onboardingDocumentCategory = [
  {
    label: "Legal",
    value: 1,
  },
  {
    label: "Finance",
    value: 2,
  },
  {
    label: "HR",
    value: 3,
  },
  {
    label: "Compliance",
    value: 4,
  },
  {
    label: "General",
    value: 5,
  },
];
export const onboardingDocumentType = [
  {
    label: "Contract",
    value: 1,
  },
  {
    label: "Agreement",
    value: 2,
  },
  {
    label: "Form",
    value: 3,
  },
  {
    label: "Report",
    value: 4,
  },
  {
    label: "Other",
    value: 5,
  },
];

export const joiningTypeOptions = [{ label: "Join", value: 1 }];
export const interviewTypeOptions = [
  { label: "In Person", value: 1 },
  { label: "Remote", value: 2 },
];
export const interviewRoundOptions = [
  { label: "Round 1", value: 1 },
  { label: "Round 2", value: 2 },
  { label: "Round 3", value: 3 },
  { label: "Round 4", value: 4 },
  { label: "Round 5", value: 5 },
];

export const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// export const DocumentStatus

//ats jobs status
export const jobStatuses = [
  { label: "Active", value: 1 },
  { label: "Positive", value: 2 },
  { label: "Open", value: 3 },
  { label: "On Hold", value: 4 },
  { label: "Hold by Client", value: 5 },
  { label: "Interview L1", value: 6 },
  { label: "Interview L2", value: 7 },
  { label: "Interview L3", value: 8 },
  { label: "Priority", value: 9 },
  { label: "Filled", value: 10 },
  { label: "Closed", value: 11 },
  { label: "Agreement Sent", value: 12 },
  { label: "Agreement Accepted", value: 13 },
];

export const MODULE_ACCESS = {
  1: ["wf", "ats", "bs","nm"],
  2: ["ats"],
  3: ["wf"],
  4: ["bs"],
  5: ["nm"],
};

export const accountPackageOptions = {
  1: "Flat",
  2: "5%",
  3: "10%",
  4: "15%",
  5: "20%",
};

export const accountWarrantyOptions = {
  1: "30 days",
  2: "60 days",
  3: "90 days",
  4: "120 days",
};

export const accountAgreementPerTermsOptions = {
  1: "30 days",
  2: "60 days",
  3: "90 days",
  4: "Split(50-50)",
  5: "Split(25-25-25-25)",
  6: "Split(3 Equal Parts)",
};

export const notesPriority = [
  { label: "Critical", value: 1 },
  { label: "High", value: 2 },
  { label: "Low", value: 3 },
  { label: "Medium", value: 4 },
];

export const sampleCompanies = [
  {
    value: "itc",
    label: "ITC",
    logo: "https://logo.clearbit.com/itcportal.com",
  },
  {
    value: "oracle",
    label: "Oracle",
    logo: "https://logo.clearbit.com/oracle.com",
  },
  {
    value: "deloitte",
    label: "Deloitte",
    logo: "https://logo.clearbit.com/deloitte.com",
  },
  {
    value: "tech-mahindra",
    label: "Tech Mahindra",
    logo: "https://logo.clearbit.com/techmahindra.com",
  },
  {
    value: "dell",
    label: "Dell",
    logo: "https://logo.clearbit.com/dell.com",
  },
  {
    value: "accenture",
    label: "Accenture",
    logo: "https://logo.clearbit.com/accenture.com",
  },
  {
    value: "ibm",
    label: "IBM",
    logo: "https://logo.clearbit.com/ibm.com",
  },
  {
    value: "cgi",
    label: "CGI",
    logo: "https://logo.clearbit.com/cgi.com",
  },
];

export const localeTimeZoneOptions = [
  { label: 1, value: "IST" },
  { label: 2, value: "EST" },
  { label: 3, value: "PST" },
];

export const localeTimeFormatOptions = [
  { label: 1, value: "12 Hour" },
  { label: 2, value: "24 Hour" },
];

export const DATE_RANGE_OPTIONS = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last Month", value: "last_month" },
  { label: "Current Month to Date", value: "current_month" },
  { label: "Year Thru Last Month-End", value: "year_thru_last_month" },
  { label: "Current Year to End", value: "current_year_to_end" },
  { label: "Custom Dates", value: "custom" },
];